// src/app/services/uvcApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IUvc, IUvcParams, UpdatePayload } from '../models';

export const uvcApi = createApi({
  reducerPath: 'uvcApi',
  baseQuery,
  endpoints: (builder) => ({
    getUvcParams: builder.query<{ uvc: IUvcParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/uvc_params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getUvc: builder.query<IUvc, number>({
      query: (id) => `/api/v1.0/ahu/uvcs/${id}`,
    }),
    getUvcAvaibleSections: builder.query<{ section_type: string }[], void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/uvc/available_sections/`,
    }),
    updateUvc: builder.mutation<IUvc, UpdatePayload<IUvc>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/uvcs/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetUvcQuery,
  useGetUvcParamsQuery,
  useGetUvcAvaibleSectionsQuery,
  useUpdateUvcMutation,
} = uvcApi;
